<script>
import Swal from 'sweetalert2'

export default {
  name: 'Mixins',
  methods: {
    async prompt(title, inputValue = '') {
      return await Swal.fire({
        type: 'question',
        title,
        input: 'text',
        inputValue: inputValue,
        showCancelButton: true,
        inputValidator(value) {
          if (!value) return 'You need to provide an unique name'
        },
      })
    },
  },
}
</script>

<style scoped></style>
